export default __webpack_public_path__ + "static/media/pic103.9feff8e4.jpg";